import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Divider } from 'grab-ui';

import {
  absAmount,
  formatPrice,
  isNegativeAmount,
} from 'common/utils/currency';
import { COMPLETED } from 'constants/new-order-status';

import styles from './pod-completed-details.less';

const PodCompletedDetails = ({ status, symbol, payOnDelivery }) => {
  const show =
    status === COMPLETED &&
    payOnDelivery &&
    !!parseFloat(payOnDelivery.totalAmount) &&
    (!!parseFloat(payOnDelivery.totalCashAmount) ||
      !!parseFloat(payOnDelivery.totalCashlessAmount));
  if (!show) return null;

  const {
    totalAmount,
    totalCashAmount,
    totalCashlessAmount,
    cashlessPaymentCompleted,
  } = payOnDelivery;

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <p className={styles.headerTitle}>{I18n.t('paymentDetails.title')}</p>
        {!!parseFloat(totalAmount) && (
          <p data-testid="total-amount" className={styles.headerTotal}>
            {formatPrice({ amount: absAmount(totalAmount), symbol })}
          </p>
        )}
      </div>

      <Divider className={styles.divider} />

      {!!parseFloat(totalCashlessAmount) && (
        <div className={styles.transaction}>
          {cashlessPaymentCompleted ? (
            <p data-testid="paid-cashless-title" className={styles.title}>
              {I18n.t('paymentDetails.paidCashless')}
            </p>
          ) : (
            <p data-testid="pay-cashless-title" className={styles.title}>
              {I18n.t('paymentDetails.payCashless')}
            </p>
          )}
          <p data-testid="cashless-amount" className={styles.amount}>
            {formatPrice({ amount: totalCashlessAmount, symbol })}
          </p>
        </div>
      )}

      {!!parseFloat(totalCashAmount) && (
        <div className={styles.transaction}>
          <p className={styles.title}>
            {isNegativeAmount(totalCashAmount)
              ? I18n.t('paymentDetails.collectCash')
              : I18n.t('paymentDetails.payCash')}
          </p>
          <p data-testid="cash-amount" className={styles.amount}>
            {formatPrice({ amount: absAmount(totalCashAmount), symbol })}
          </p>
        </div>
      )}
    </div>
  );
};

PodCompletedDetails.propTypes = {
  status: PropTypes.string,
  symbol: PropTypes.string,
  payOnDelivery: PropTypes.shape({
    totalAmount: PropTypes.string,
    totalCashAmount: PropTypes.string,
    totalCashlessAmount: PropTypes.string,
    cashlessPaymentCompleted: PropTypes.bool,
  }),
};

PodCompletedDetails.defaultProps = {
  status: '',
  symbol: '',
  payOnDelivery: {
    items: [],
    totalAmount: '',
    totalCashAmount: '',
    totalCashlessAmount: '',
    cashlessPaymentCompleted: false,
  },
};

export default PodCompletedDetails;
